$(function () {
  // Portal the off-canvas menu and the age gate to <body> so they escape the
  // header's stacking context (.section-header is sticky, which would trap
  // them below the .bg-click overlay). Same reason as .cashback-drawer below.
  $("#menu-mobile, #pop_up").appendTo("body");

  $(".header-nav nav ul > li:not(.submenu li)").hover(
    function () {
      $(this).addClass("open-menu"),
        $(this).children(".submenu").addClass("open-menu");
    },
    function () {
      $(this).removeClass("open-menu"),
        $(this).children(".submenu").removeClass("open-menu");
    }
  ),
    $(".toggle-menu").on("click", function () {
      $("#menu-mobile, .bg-click").addClass("active_menu_mob");
    }),
    $(".bg-click, .close-menu").on("click", function () {
      $("#menu-mobile, .bg-click").removeClass("active_menu_mob");
    }),
    $("#menu-mobile .nav-departments nav ul >li:not(.submenu li)").on(
      "click",
      function () {
        if ($(this).hasClass("open-menu")) {
          $(this).removeClass("open-menu");
          $(this).children(".submenu").removeClass("open-menu");
        } else {
          $(this).siblings().removeClass("open-menu");
          $(this).siblings().children(".submenu").removeClass("open-menu");
          $(this).addClass("open-menu");
          $(this).children(".submenu").addClass("open-menu");
        }
      }
    ),
    $("#menu-mobile .submenu").on("click", function (e) {
      e.stopPropagation();
    }),
    (localStorage.getItem("popup") &&
      ($("#pop-up-f-buy,.bg-click").removeClass("active"),
      JSON.parse(localStorage.getItem("popup")).remember)) ||
      handlePopUp(),
    document.cookie.includes("vinsel-cookie") ||
      ($("#cookie-consent").addClass("active"),
      $("#cookie-consent button").on("click", () => {
        $("#cookie-consent").removeClass("active"),
          (document.cookie = "cookieBy= vinsel-cookie; max-age=2592000");
      })),
    $("#search-header").on("click", function () {
      $(".wrapper-search-result").addClass("active");
    }),
    1010 < $(window).width() &&
      ($(".wrapper-search-result").on("mouseenter", function () {
        $(this).addClass("active");
      }),
      $(".wrapper-search-result").on("mouseleave", function () {
        $(this).removeClass("active");
      })),
    $(".close-search-result").on("click", function () {
      setTimeout(() => {
        $(".wrapper-search-result").removeClass("active");
      }, 200);
    }),
    $("#search-header input[type='text']").on("keyup", async function () {
      var e = $(this).val(),
        e = await (
          await fetch(
            window.Shopify.routes.root +
              `search/suggest.json?q=${e}&resources[limit]=5&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.sku`
          )
        ).json();
      let a = $(".wrapper-search-result");
      $(".wrapper-search-result li").remove(),
        e?.resources?.results?.products.forEach(
          ({ title: e, url: t, image: n }) => {
            t = $(`
                  <li>
                      <a href=${t}>
                          <div class="result-search-image">
                              <img src="${n}"/>                        
                          </div>
                          <div class="result-search-right">
                              <h3>${e}</h3>                                                    
                          </div>
                      </a>
                  </li>
              `);
            a.append(t);
          }
        );
    });

  var n = document.links;
  for (let e = 0, t = n.length; e < t; e++)
    !n[e].hostname.endsWith(window.location.hostname) && (n[e], (n[e].target = "_blank"), (n[e].rel = "noreferrer noopener"));
  formatStarInKitShelf();

    $(".jdgm-prev-badge__stars").each((idx,el) => {
    const prevScore  = $(el).data("score").toString();
    const newScore = prevScore.replace('.',',');
    $(el).attr('data-score',newScore)
  });

    $(".total-stars-custom p").each((idx,el) => {
    const prevScore  = $(el).html().toString().replace('.',',');
    $(el).html(prevScore)
  });
});
let createCollectionSwiper = (e) => {
  new Swiper(`#${e} .swiper`, {
    loop: !0,
    slidesPerView: 1.1,
    spaceBetween: 8,
    navigation: {
      nextEl: `#${e} .swiper-button-next-custom`,
      prevEl: `#${e} .swiper-button-prev-custom`,
    },
    breakpoints: {
      548: { slidesPerView: 2, spaceBetween: 12 },
      1024: { slidesPerView: 3, spaceBetween: 12 },
      1250: { slidesPerView: 4, spaceBetween: 10 },
    },
  });
};
function handlePopUp() {
  $(".bg-click, #pop_up").addClass("active"),
    $("#pop_up .actions button").on("click", function (e) {
      e.target.classList.contains("not-have")
        ? (window.location =
            "https://www.abrabe.org.br/responsabilidade-social/autorregulamentacao-publicitaria/")
        : ((e = $("#remember-choice")[0].checked),
          localStorage.setItem(
            "popup",
            JSON.stringify({ underAge: !1, remember: e })
          ),
          $("#pop-up-f-buy,.bg-click").addClass("active"),
          $("#pop_up .first-step,  #pop_up, .bg-click").removeClass("active"));
    }),
    $(".accept-cookies").on("click", function () {
      $(".bg-click, #pop_up").removeClass("active");
    });
}
function handleMutation() {
  $(".shelf-form-action").off("submit"),
    $(".quantity-buttons").off("click"),
    $(".shelf-form-action").on("submit", function (e) {
      e.preventDefault(), serializeForm($(this));
    }),
    $(".quantity-buttons").on("click", function (e) {
      e.preventDefault();
      (e = $(this)),
        ($inputQuantity = e.siblings("input")[0]),
        (e = e.data("action"));
      "minus" == e ? $inputQuantity.stepDown() : $inputQuantity.stepUp();
    });
}
if (
  ($(".shelf-form-action").on("submit", function (e) {
    e.preventDefault(), serializeForm($(this));
  }),
  0 < $(".search-result-items").length)
) {
  let e = new MutationObserver(function (e) {
    e.forEach(function (e) {
      handleMutation();
    });
  });
  e.observe($(".search-result-items")[0], { childList: !0, subtree: !0 });
}
function bindElementsListeners() {
  bindToggleBtnsMinicart(),
    bindToggleBtnsCashbackDrawer(),
    bindQuantityStepsMinicartCard(),
    bindRemoveItemMinicart();
}

function bindToggleBtnsCashbackDrawer() {
  // Portal the drawer to <body> so it escapes the header's stacking context
  // (header#header has position: relative; z-index: 2 on desktop, which would
  // otherwise trap the drawer below the .bg-click overlay).
  $(".cashback-drawer").appendTo("body");

  $(".open-cashback").on("click", function () {
    $(".cashback-drawer,.bg-click").addClass("cashback-drawer--active");
    $(".cashback-drawer").attr("aria-hidden", "false");
  });
  $(".cashback-drawer .cashback-drawer-close, .cashback-drawer [data-cashback-drawer-back]").on("click", function () {
    $(".cashback-drawer,.bg-click").removeClass("cashback-drawer--active");
    $(".cashback-drawer").attr("aria-hidden", "true");
  });
  $(".bg-click").on("click", function () {
    $(".cashback-drawer,.bg-click").removeClass("cashback-drawer--active");
    $(".cashback-drawer").attr("aria-hidden", "true");
  });
}
function bindButtonsShowcasePdp() {
  $(".product-recommendations .shelf-form-action").on("submit", function (e) {
    e.preventDefault(), serializeForm($(this));
  }),
    $(".product-recommendations .quantity_shelf").on("click", function (e) {
      e.preventDefault();
    }),
    $(".product-recommendations .quantity-buttons").on("click", function (e) {
      e.preventDefault();
      (e = $(this)),
        ($inputQuantity = e.siblings("input")[0]),
        (e = e.data("action"));
      "minus" == e ? $inputQuantity.stepDown() : $inputQuantity.stepUp();
    });
}
function debounce(t, n) {
  let a;
  return function (...e) {
    clearTimeout(a), (a = setTimeout(() => t.apply(this, e), n));
  };
}
function bindQuantityStepsMinicartCard() {
  $(".quantity-buttons-cart").on("click", function () {
    const $this = $(this);
    const key = $($this.closest(".cart-drawer-item")[0]).attr(
      "data-line-item-key"
    );
    const maxItens = $this.data("max-items");
    const inputQuantity = parseInt($this.siblings("input")[0].value);
    const action = $this.data("action");
    console.log(maxItens);

    let newQtd = inputQuantity;

    if (action == "minus") {
      if (newQtd > 1) {
        newQtd = inputQuantity - 1;
      }
    } else if (action == "plus") {
      if (parseInt(maxItens) == inputQuantity) {
        return;
      } else {
        newQtd = inputQuantity + 1;
      }
    } else {
      $(this).parent().parent().find("div.exceed-2").css({ display: "block" });
      $(this).parent().parent().find("div.exceed").css({ display: "none" });
    }

    if (action == "plus" || action == "minus") {
      $this.siblings("input")[0].value = newQtd;
      updateMinicart(key, newQtd);
    }
  });
}

function bindToggleBtnsMinicart() {
  $(".open-minicart").on("click", function () {
    $(".cart-drawer,.bg-click").addClass("cart-drawer--active");
  }),
    $(".cart-drawer .cart-drawer-header-right-close,.bg-click").on(
      "click",
      (e) => {
        $(".cart-drawer,.bg-click").removeClass("cart-drawer--active");
      }
    );
}
function bindRemoveItemMinicart() {
  $(".cart-drawer-remove-btn").on("click", function () {
    var e = $(this);
    deleteItemMinicart(
      $(e.closest(".cart-drawer-item")[0]).attr("data-line-item-key"),
      0
    );
  });
}
function serializeForm(e) {
  var t = { items: [] };
  let n = {};
  e.serializeArray().forEach((e) => {
    n[e.name] = parseInt(e.value);
  }),
    t.items.push(n),
    n.quantity || (n.quantity = 0),
    n.quantity > n["product-quantity"] &&
      ((e = parseInt(
        $(
          `.cart-drawer-items .cart-drawer-item[data-line-item-key^='${n.id}'] .cart-drawer-quantity-selector input`
        ).val()
      )),
      (e = Math.abs((e || 0) - n["product-quantity"])),
      (n.quantity = e)),
    console.log(t),
    addToCart(t);
}
function addToCart(e, t) {
  $.ajax({
    url: window.Shopify.routes.root + "cart/add.js",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    type: "POST",
    dataType: "json",
    data: JSON.stringify(e),
    success: function (e) {
      getAndUpdateMinicartInFront(),
        manageBonusItem(true),
        updateItemCountCart(),
        "pdp-form" == t
          ? (window.location.href = "/checkout")
          : $(".cart-drawer,.bg-click").addClass("cart-drawer--active");
    },
    error: function (e) {
      console.error("erro in request", e);
    },
  });
}
function getAndUpdateMinicartInFront() {
  // Salvar o scroll atual antes de substituir o DOM
  const minicartItems = document.querySelector(".cart-drawer-items");
  const scrollTopBeforeUpdate = minicartItems ? minicartItems.scrollTop : 0;

  $.ajax({
    url: "/?section_id=cart-drawer",
    method: "GET",
    success: function (responseHTML) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseHTML;

      const newCartDrawerHTML = tempDiv.querySelector(".cart-drawer").innerHTML;
      document.querySelector(".cart-drawer").innerHTML = newCartDrawerHTML;

      // Restaurar o scroll após substituir o conteúdo
      const updatedMinicartItems = document.querySelector(".cart-drawer-items");
      if (updatedMinicartItems) {
        updatedMinicartItems.scrollTop = scrollTopBeforeUpdate;
      }

      if ($("body").hasClass("template-cart")) {
        $.ajax({
          url: "/?section_id=main-cart",
          method: "GET",
          dataType: "text",
          success: function (html) {
            const temp = document.createElement("div");
            temp.innerHTML = html;
            const newMainCart = temp.querySelector("#cart-template").innerHTML;
            document.querySelector("#cart-template").innerHTML = newMainCart;
            bindElementsListeners();
          },
          error: function (err) {
            console.error("Erro ao atualizar main-cart", err);
          },
        });
      } else {
        bindElementsListeners();
      }
    },
    error: function (err) {
      console.error("Erro ao atualizar cart-drawer", err);
    },
  });
}
$(".quantity_shelf").on("click", function (e) {
  e.preventDefault();
}),
  $(".quantity-buttons").on("click", function (e) {
    e.preventDefault();
    (e = $(this)),
      ($inputQuantity = e.siblings("input")[0]),
      (e = e.data("action"));
    "minus" == e ? $inputQuantity.stepDown() : $inputQuantity.stepUp();
  }),
  document.addEventListener("DOMContentLoaded", function () {
    var e;
    bindElementsListeners(),
      0 < $("#product-page").length &&
        0 < $("#would_like_too .product-recommendations").length &&
        ((e = document.querySelector(
          "#would_like_too .product-recommendations"
        )),
        new MutationObserver(bindButtonsShowcasePdp).observe(e, {
          childList: !0,
          subtree: !0,
        }));
  });
let xhr = null;
function updateMinicart(e, t) {
  xhr && xhr.abort();
  xhr = $.ajax({
    url: "/cart/change.js",
    type: "POST",
    dataType: "json",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    data: JSON.stringify({ id: e, quantity: t }),
    success: async function () {
      await manageBonusItem(),
        updateItemCountCart(),
        getAndUpdateMinicartInFront();
    },
    error: function (e) {
      console.error(e);
    },
  });
}
function deleteItemMinicart(e, t) {
  $.ajax({
    url: "/cart/change.js",
    type: "POST",
    dataType: "json",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    data: JSON.stringify({ id: e, quantity: t }),
    success: async function (e) {
      getAndUpdateMinicartInFront(),
        $(".minicart-count-items").html(e.item_count);
    },
    error: function (e) {
      console.error(e);
    },
  });
}
function updateItemCountCart() {
  $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: "json",
    async: !0,
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    success: function (e) {
      $(".minicart-count-items").html(e.item_count);
    },
    error: function (e) {
      console.error(e);
    },
  });
}
function formatStarInKitShelf() {
$(".kit-reviews-inline:not(.kit-reviews-custom)").each((e, t) => {
  let ratings = [], reviews = [];
  
  $(t).find(".jdgm-prev-badge").each((i, el) => {
    const rating = parseFloat($(el).data("average-rating")) || 0;
    const numReviews = parseInt($(el).data("number-of-reviews")) || 0;

    if (numReviews > 0) {
      ratings.push(rating * numReviews); // peso do rating * quantidade de avaliações
      reviews.push(numReviews);
    }
  });

  const totalReviews = reviews.reduce((sum, curr) => sum + curr, 0);
  const weightedAverage = totalReviews > 0 ? ratings.reduce((sum, curr) => sum + curr, 0) / totalReviews : 0;

  const starsHTML = createStars(weightedAverage);
  const textHTML = $("<div>").append(
    totalReviews > 0
      ? `<span class='total-resume-custom'>${totalReviews} Avaliações</span>`
      : "<span class='total-resume-custom'>Sem avaliações</span>"
  );

  $(t).append(starsHTML).append(textHTML);
  $(t).addClass("kit-reviews-custom");
});
}
function createStars(t) {
  let e = 0;
  e =
    0 < t
      ? parseInt(t) != parseFloat(t)
        ? decimalFormatter(t, 2)
        : t + ".0"
      : null;
  var n = $("<div class='total-stars-custom'></div>");
  for (let e = 1; e <= 5; e++) {
    var a = $("<span></span>");
    t >= e
      ? a.addClass("jdgm-star jdgm--on")
      : t > e - 1 + 0.1
      ? a.addClass("jdgm-star jdgm--half")
      : a.addClass("jdgm-star jdgm--off"),
      n.append(a);
  }
   return e && n.append($(`<p style="padding-left:.55rem">${e}</p>`)), n;
}
function decimalFormatter(e, t) {
  return e.toFixed(t);
}
$(window).on("unload", function () {
  xhr && xhr.abort();
});
const manageBonusItem = async (shouldUpdateFront) => {
  const getCartAndProcessBonus = async () => {
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    const cartDrawer = document.querySelector(".cart-drawer-items");
    const bonusItemVariantId = Number(
      cartDrawer.getAttribute("bonusitemvariantid")
    );
    const minCartValue = Number(cartDrawer.getAttribute("mincartvalue"));
    const bonusItemPrice = Number(cartDrawer.getAttribute("bonusitemprice"));

    const cartValue = cart.total_price;
    const eligibleBonusQuantity = cartValue >= minCartValue ? 1 : 0;
    const bonusFlag = localStorage.getItem("bonus_added") === "true";

    if (eligibleBonusQuantity > 0) {
      if (!bonusFlag) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: bonusItemVariantId,
                quantity: eligibleBonusQuantity,
              },
            ],
          }),
        });
        localStorage.setItem("bonus_added", "true");
        if (shouldUpdateFront) getAndUpdateMinicartInFront();
      }
    }

    if (eligibleBonusQuantity <= 0) {
      localStorage.removeItem("bonus_added");
    }
  };

  if (shouldUpdateFront) {
    const intervalBonus = setInterval(async () => {
      if (document.querySelector(".cart-drawer-items")) {
        clearInterval(intervalBonus);
        try {
          console.log("entrei");
          await getCartAndProcessBonus();
        } catch (err) {
          console.error("Erro ao gerenciar brinde (update front):", err);
        }
      }
    }, 500);
  } else {
    if (document.querySelector(".cart-drawer-items")) {
      try {
        await getCartAndProcessBonus();
      } catch (err) {
        console.error("Erro ao gerenciar brinde:", err);
      }
    }
  }
};

(function () {
  var savedDisplay = null;

  function setWidgetHidden(hidden) {
    var widget = document.querySelector('#superchat-widget-root');
    if (!widget) return;
    if (hidden) {
      savedDisplay = widget.style.display;
      widget.style.setProperty('display', 'none', 'important');
    } else {
      if (savedDisplay === '') {
        widget.style.removeProperty('display');
      } else if (savedDisplay !== null) {
        widget.style.setProperty('display', savedDisplay, 'important');
      }
      savedDisplay = null;
    }
  }

  function checkDrawers() {
    var anyOpen =
      document.querySelector('#menu-mobile.active_menu_mob') ||
      document.querySelector('.cart-drawer.cart-drawer--active');
    setWidgetHidden(!!anyOpen);
  }

  var observer = new MutationObserver(checkDrawers);

  document.addEventListener('DOMContentLoaded', function () {
    var menuMobile = document.getElementById('menu-mobile');
    var cartDrawer = document.querySelector('.cart-drawer');
    if (menuMobile) observer.observe(menuMobile, { attributes: true, attributeFilter: ['class'] });
    if (cartDrawer) observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  });
})();

// Swipe-to-close for the off-canvas drawers: the mobile menu slides in from the
// left, so it closes on a left swipe; the cart and cashback drawers slide in
// from the right, so they close on a right swipe. The gesture toggles the exact
// same classes as the X buttons above, so the CSS transition handles the
// animation.
(function () {
  var MIN_DISTANCE = 60; // px travelled on the X axis before it counts
  var MAX_OFF_AXIS = 0.75; // |dy| / |dx| tolerated, so vertical scrolls are ignored

  var drawers = [
    {
      selector: '#menu-mobile',
      activeClass: 'active_menu_mob',
      direction: -1,
      close: function () {
        $('#menu-mobile, .bg-click').removeClass('active_menu_mob');
      },
    },
    {
      selector: '.cart-drawer',
      activeClass: 'cart-drawer--active',
      direction: 1,
      close: function () {
        $('.cart-drawer, .bg-click').removeClass('cart-drawer--active');
      },
    },
    {
      // "Programa de Cashback" — slides in from the right like the cart
      // drawer. Mirrors bindToggleBtnsCashbackDrawer's close handler,
      // aria-hidden included.
      selector: '.cashback-drawer',
      activeClass: 'cashback-drawer--active',
      direction: 1,
      close: function () {
        $('.cashback-drawer, .bg-click').removeClass('cashback-drawer--active');
        $('.cashback-drawer').attr('aria-hidden', 'true');
      },
    },
  ];

  var tracked = null;

  function openDrawerAt(target) {
    if (!target || typeof target.closest !== 'function') return null;
    for (var i = 0; i < drawers.length; i++) {
      var element = target.closest(drawers[i].selector);
      if (element && element.classList.contains(drawers[i].activeClass)) {
        return drawers[i];
      }
    }
    return null;
  }

  // A swipe that ends on a link or a button would otherwise still fire its
  // click, so swallow the next one.
  function swallowNextClick() {
    function block(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    document.addEventListener('click', block, true);
    setTimeout(function () {
      document.removeEventListener('click', block, true);
    }, 400);
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      tracked = null;
      if (e.touches.length !== 1) return;
      var drawer = openDrawerAt(e.target);
      if (!drawer) return;
      tracked = {
        drawer: drawer,
        startX: e.touches[0].clientX,
        startY: e.touches[0].clientY,
      };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      // A second finger means a pinch or a zoom, not a swipe.
      if (tracked && e.touches.length > 1) tracked = null;
    },
    { passive: true }
  );

  document.addEventListener('touchcancel', function () {
    tracked = null;
  });

  document.addEventListener('touchend', function (e) {
    var gesture = tracked;
    tracked = null;
    if (!gesture || e.changedTouches.length !== 1) return;

    var deltaX = e.changedTouches[0].clientX - gesture.startX;
    var deltaY = e.changedTouches[0].clientY - gesture.startY;

    if (Math.abs(deltaX) < MIN_DISTANCE) return;
    if (Math.abs(deltaY) > Math.abs(deltaX) * MAX_OFF_AXIS) return;
    if (deltaX * gesture.drawer.direction < 0) return;

    gesture.drawer.close();
    swallowNextClick();
  });
})();
